import { render, staticRenderFns } from "./OnboardingLocation.vue?vue&type=template&id=1bc3164b&"
import script from "./OnboardingLocation.vue?vue&type=script&lang=js&"
export * from "./OnboardingLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports